<template>
    <div class="container-fluid py-3 px-4">

        <div class="border border-1 rounded-3 p-3 mb-2 ">
            <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
                <i class="bi-pencil-square display-4 me-2 text-primary"></i>
                <div>
                    <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
                        CONTRATOS
                    </p>
                    <p class="mb-0 tituloResaltado fs-4 fw-bold">
                        BASE DE SOLICITUDES
                    </p>
                </div>
            </div>
        </div>
        <div class="card border border-1 rounded-3 p-3 mb-2">
            <div class="table-responsive">
                <table class="table table-bordered ">
                    <thead class="reducirTamaño">
                        <tr class="bg-solimano text-white text-center text-nowrap">
                            <th scope="col">N° SOLI</th>
                            <th>NOMBRE Y APELLIDOS</th>
                            <th scope="col">ESTADO</th>
                            <th scope="col">POSTULACION</th>
                            <th scope="col">CUENTA</th>
                            <th scope="col">ETAPA</th>
                            <th scope="col">FECH. EJECU</th>
                            <th scope="col">ETAPA</th>
                            <th scope="col">FECH. EJECU</th>
                            <th scope="col">ETAPA</th>
                            <th scope="col">FECH. EJECU</th>

                        </tr>
                    </thead>
                    <tbody class="text-nowrap text-center align-middle">
                        <tr v-for="items in basePostulantes.slice(0, 10)" :key="items.idSolxPostulante"
                            class="text-center align-middle text-nowrap reducirTamaño">

                            <td><strong>{{ items.idMaeSolicitud }}</strong></td>


                            <td class="text-start px-2">
                                <strong>{{ items.nombre }}</strong> <br>
                                <small class="text-muted">DNI - <strong class="text-muted">{{ items.posNroDocumento
                                        }}</strong></small>
                                <br>
                                <div class="text-muted small mb-1">
                                    <i class="bi bi-envelope text-primary me-1"></i>
                                    {{ items.posCorreo }}
                                </div>
                            </td>

                            <td :class="{
                                'text-success fw-bold': items.solDesMotivo === 'SELECCIONADO',
                                'text-primary fw-bold': items.solDesMotivo === 'APTO'
                            }">
                                <i class="bi" :class="{
                                    'bi-check-circle-fill text-success': items.solDesMotivo === 'SELECCIONADO',
                                    'bi-check-circle-fill text-primary': items.solDesMotivo === 'APTO'
                                }"></i>
                                {{ items.solDesMotivo }}
                            </td>

                            <td class="text-start ">
                                <i class="bi bi-briefcase text-primary me-1"></i><small class="text-muted">{{
                                    items.nomPuesto }}</small><br>
                                <i class="bi bi-geo-alt text-primary me-1"></i><small class="text-muted">{{
                                    items.desUbigeo }}</small><br>
                                <i class="bi bi-building text-primary me-1"></i><small class="text-muted">{{
                                    items.subSubCentroCosto }}</small>
                            </td>


                            <td class="text-start px-2">
                                <strong>{{ items.centroCosto }}</strong><br>
                                <small class="text-muted"> {{ items.subCentroCosto }}</small> <br>
                                <small class="text-muted"> {{ items.subSubCentroCosto }}</small>
                            </td>

                            <td class="px-2">
                                <button @click="editSeleccion(1)" class="btn btn-success py-1 my-0">
                                    <i class="bi bi-person-bounding-box"></i>
                                </button>
                            </td>
                            <td></td>

                            <td class="px-2">
                                <button @click="editContrato(1)" class="btn btn-success py-1 my-0">
                                    <i class="bi bi-vector-pen"></i>
                                </button>
                            </td>

                            <td></td>

                            <td class="px-2">
                                <button @click="editSeleccion(1)" class="btn btn-success py-1 my-0">
                                    <i class="bi bi-person-bounding-box"></i>
                                </button>
                            </td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CopiasBaseRqPostulantes',

    data() {
        return {
            idTrabajador: "",
            basePostulantes: []
        };
    },

    mounted() {

    },

    created() {
        this.idTrabajador = localStorage.getItem('idTrabajdor')
        this.ObternerPostulantesRq()
    },

    methods: {

        ObternerPostulantesRq() {
            this.axios.get(`SolicitudPostulante/ListaSolicitudMasivo?idTrabajador=${this.idTrabajador}&idCategoria=1`).then(r => {
                console.log(r.data);
                this.basePostulantes = r.data
            })
        },


        editSeleccion(uno) {
            console.log(uno)
        },

        editContrato(unos) {
            console.log(unos)
        },
    },
};
</script>

<style scoped>
.boton-estiloCuadrado {
    padding: 0.2rem 0.55rem;
    cursor: pointer;
}

.buscar-estiloCuadrado {
    border-radius: 0;
    font-size: 0.65rem;
    background-color: transparent;
    /* Fondo transparente */
}

.tabla-estiloCompreso {
    padding: 0.3rem 0.55rem;
}

.input-group {
    max-width: 350px;
}

.row.mb-3 {
    margin-bottom: 1rem !important;
}

.tabla-estiloCompreso {
    padding: 0.3rem 0.55rem;
}

.reducirTamaño {
    font-size: 0.65rem;
}

.bg-solimano {
    background: #1565c0;
}

.bg-solimano-table {
    background: #0080c8;
}

.btn-solimano {
    background: #0080c8;
}

.tamaño {
    font-size: 0.65rem;

    font-weight: 800;
    color: #002c5d;
}

table,
tr,
h6 {
    page-break-inside: avoid;
}

.cursor-pointer {
    cursor: pointer;
}


#file-upload {
    display: none;
}

/* Fondo del modal translúcido con desenfoque */
.custom-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(16, 16, 16, 0.6);
    /* transparencia */
    backdrop-filter: blur(0.5px);
    /* efecto de desenfoque */
    -webkit-backdrop-filter: blur(5px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

/* Caja del modal */
.custom-modal {
    background: rgba(255, 255, 255, 0.85);
    border-radius: 10px;
    padding: 4rem 5rem;
    text-align: center;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
}



/* Texto del modal */
.text {
    color: #333;
    font-size: 0.95rem;
    font-weight: 500;
}
</style>
